import { useContext } from "react";
import { UploaderFlowContext } from "../provider/uploaderFlowProvider";
import {
  Data,
  RawData,
  RowHook,
  StepState,
  TableHook,
  IUploaderColumnConfig,
  ColumnMappings,
  UploaderSubmissionData,
  StepChangeEvent
} from "../types/types";
import { GridTypes } from "../../../../enums";
import { AddonConstructor, IAddonRegistry } from "../addons/AddonRegistry";

export type UploaderFlowProps<T extends string> = {
  isOpen: boolean;
  onClose: () => void;
  gridType: GridTypes;
  fields: IUploaderColumnConfig[];
  // Runs after file upload step, receives and returns raw sheet data
  uploadStepHook?: (data: RawData[]) => Promise<RawData[]>;
  // Runs after header selection step, receives and returns raw sheet data
  selectHeaderStepHook?: (
    headerValues: RawData,
    data: RawData[]
  ) => Promise<{ headerValues: RawData; data: RawData[] }>;
  // Runs once before validation step
  matchColumnsStepHook?: (table: Data<T>[], rawData: RawData[], columns: ColumnMappings) => Promise<Data<T>[]>;
  // Runs after column matching and on entry change
  rowHook?: RowHook<T>;
  // Runs after column matching and on entry change
  tableHook?: TableHook<T>;
  // Function called after user finishes the flow.
  onSubmit?: (data: UploaderSubmissionData<any>) => void | Promise<any>;
  maxRecords?: number;
  // Maximum upload filesize (in bytes)
  maxFileSize?: number;
  // Automatically map imported headers to specified fields if possible.
  autoMapHeaders?: boolean;
  // Possibly use for entityRelations automapping functionality
  autoMapEntityRelationValues?: boolean;
  initialStepState?: StepState;
  // TODO: handle date format
  // Sets SheetJS dateNF option. If date parsing is applied, date will be formatted
  dateFormat?: string;
  // Sets SheetJS "raw" option. If true, parsing will only be applied to xlsx date fields.
  parseRaw?: boolean;
  // Optional addons to include in the uploader
  addons?: AddonConstructor[];
  // Optional custom addon registry
  addonRegistry?: IAddonRegistry;

  onStepChangeHook?: (ev: StepChangeEvent) => void;
  onStepSelectHook?: (step: number) => void;
  activeStep?: number;
};
export const useUploaderFlow = <T extends string>() => useContext<UploaderFlowProps<T>>(UploaderFlowContext);
